import React, { useEffect, useRef } from 'react';

const MapWithPlacePicker = ({ location, setLocation }) => {
  const mapRef = useRef(null);
  const markerRef = useRef(null);

  useEffect(() => {
    const init = async () => {
      await customElements.whenDefined('gmp-map');

      const map = document.querySelector('gmp-map');
      const marker = document.querySelector('gmp-advanced-marker');
      const placePicker = document.querySelector('gmpx-place-picker');

      if (!map || !marker || !placePicker) return;

      mapRef.current = map;
      markerRef.current = marker;

      map.innerMap.setOptions({ mapTypeControl: false });

      placePicker.addEventListener('gmpx-placechange', () => {
        const place = placePicker.value;
        if (!place || !place.location) {
          alert('No location details available');
          return;
        }

        const lat = place.location.lat();
        const lng = place.location.lng();

        setLocation({ type: 'Point', coordinates: [lng, lat] });

        if (place.viewport) {
          map.innerMap.fitBounds(place.viewport);
        } else {
          map.center = place.location;
          map.zoom = 17;
        }

        marker.position = place.location;
      });
    };

    init();
  }, [setLocation]);

  const handleCurrentLocation = () => {
    if (!navigator.geolocation) {
      alert('Geolocation is not supported by your browser.');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        setLocation({ type: 'Point', coordinates: [lng, lat] });

        const map = mapRef.current;
        const marker = markerRef.current;

        if (map && marker) {
          const latLng = { lat, lng };
          map.center = latLng;
          map.zoom = 17;
          marker.position = latLng;
        }
      },
      (error) => {
        switch (error.code) {
          case error.PERMISSION_DENIED:
            alert('Location access denied. Please allow location permission in your browser.');
            break;
          case error.POSITION_UNAVAILABLE:
            alert('Location information is unavailable.');
            break;
          case error.TIMEOUT:
            alert('Location request timed out.');
            break;
          default:
            alert('An unknown error occurred while fetching location.');
        }
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  };

  return (
    <>
      <gmpx-api-loader
        key="#"
        solution-channel="GMP_GE_mapsandplacesautocomplete_v1"
      />

      <gmp-map
        center={`${location.coordinates[1]},${location.coordinates[0]}`}
        zoom="13"
        map-id="3747b2ba3dcd1415"
        style={{ height: '30vh', width: '90%' }}
      >
        <div
          slot="control-block-start-inline-start"
          style={{ padding: '20px', display: 'flex', gap: '8px', alignItems: 'center' }}
        >
          <gmpx-place-picker placeholder="Enter an address" />

          <button
            onClick={handleCurrentLocation}
            title="Use current location"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              padding: '0 12px',
              height: '40px',
              backgroundColor: '#fff',
              border: '1px solid #ccc',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: 500,
              color: '#1a73e8',
              boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
              whiteSpace: 'nowrap',
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="3" />
              <path d="M12 2v3M12 19v3M2 12h3M19 12h3" />
            </svg>
            Use Current Location
          </button>
        </div>

        <gmp-advanced-marker />
      </gmp-map>
    </>
  );
};

export default MapWithPlacePicker;